import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import { PrismicLink, PrismicRichText } from '@prismicio/react'

const Card = ({ fields }) => {
  return (
    <li
      className={`component-card bg-white dark:bg-gray-700 border border-gray-50 dark:border-gray-800 shadow-sm shadow-gray-100 dark:shadow-gray-700/50 p-2 relative flex flex-col flex-1 ${
        fields.button_link?.url && ' transform transition duration-300 ease hover:scale-105 hover:shadow-lg hover:shadow-gray-200 hover:dark:shadow-purple-300/10'
      }`}>
      {fields.image.gatsbyImageData && (
        <div className='flex-shrink-0 relative'>
          <GatsbyImage image={fields.image.gatsbyImageData} className='filter saturate-125' alt={fields.image.alt} />
        </div>
      )}
      <div className='flex-1 m-3 flex flex-col'>
        <div className='space-y-4 mb-3'>
          {fields.intro && (
            <div className='not-prose text-sm inline-block leading-6 py-0.5 px-1.5 rounded-sm self-start uppercase tracking-wider bg-indigo-50 text-indigo-700 dark:bg-indigo-600 dark:text-indigo-50'>
              {fields.intro}
            </div>
          )}
          {fields.card_title && <h3>{fields.card_title}</h3>}
          {fields.text?.html && (
            <div className='prose dark:prose-invert'>
              <PrismicRichText field={fields.text.richText} />
            </div>
          )}
        </div>
        <PrismicLink className='link block mt-auto font-semibold hover:text-indigo-600 text-fuchsia-600 dark:text-fuchsia-300 dark:hover:text-purple-300' field={fields.button_link}>
          {fields.button_text} <span className='text-purple-500 inline-block transform transition duration-300 hover:translate-x-full'>→</span>
        </PrismicLink>
      </div>
    </li>
  )
}

export default Card
